import React from "react";
import ESignFileSourceInfo from "./ESignFileSourceInfo";

interface Props {
  file: server.dto.ESignFile
}

const ReadonlyFileRowCard = (props: Props) => {
  return <div className="readonly-file-row-card">
    <div className="grow1">
      <div>
        <a href={props.file.downloadUrl + "?requestSource=adminPage"}>{props.file.fullName}</a>
      </div>
      <ESignFileSourceInfo file={props.file} />
    </div>
    <div>
      {props.file.contentLengthText}
    </div>
  </div>;
};

export default ReadonlyFileRowCard;